import styled from "styled-components";
import { Grid, InputLabel, Select } from "@material-ui/core";

export const STFormWrapper = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;
  width: 400px;
`;

export const STTypeGrid = styled(Grid)`
  && {
    margin-top: 20px;
  }
`;

export const STInputLabelType = styled(InputLabel)`
  && {
    font-size: 13px;
    padding-bottom: 4px;
  }
`;

export const STStateGrid = styled(Grid)`
  && {
    padding-top: 8px;
    padding-bottom: 12px;
  }
`;

export const STSelect = styled(Select)`
  && {
    width: 150px;
  }
`;

export const STTypeSelectGrid = styled(Grid)`
  && {
    padding-right:5px;
    display: inline;
  }
`;
